import SubscribeForm from '@frontend/features/fluent-form/subscribe-form/SubscribeForm'
import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import { scrollToTop } from '@frontend/libs/utils'
import { ArrowLongUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline'
import { Accordion, AccordionItem, Button, Link } from '@nextui-org/react'
import { __ } from '@wordpress/i18n'

function MobileFooter() {
  const currentYear = new Date().getFullYear()
  const { menus } = useSiteConfiguration()

  return (
    <>
      <Button
        className="flex h-auto max-h-none w-full justify-between border-t border-gray-300 bg-white py-4 hover:opacity-100"
        color="primary"
        disableAnimation
        onClick={scrollToTop}
        variant="light"
      >
        <span className="font-medium uppercase">
          {__('Back to top', 'asavagroup')}
        </span>{' '}
        <ArrowLongUpIcon className="h-5 w-5" />
      </Button>
      <footer className="bg-[#f7f8fa]">
        <div className="container pt-10">
          <div className="mb-10">
            <SubscribeForm />
          </div>
          {menus && menus?.footer?.length > 0 && (
            <Accordion className="border-b border-t border-gray-300 p-0">
              {menus.footer.map((menu) => (
                <AccordionItem
                  aria-label={menu.title}
                  classNames={{
                    content: 'border-t border-gray-300',
                    indicator: 'data-[open=true]:rotate-180 text-primary/60',
                    title: 'font-normal uppercase text-base',
                  }}
                  indicator={<ChevronDownIcon className="h-5 w-5" />}
                  key={menu.title}
                  title={menu.title}
                >
                  <div className="space-y-6 px-6 py-4">
                    {menu?.items.map((item) => (
                      <Link
                        className="block text-sm uppercase"
                        color="foreground"
                        href={item.url}
                        key={item.id}
                        target={item.target}
                      >
                        {item.title}
                      </Link>
                    ))}
                  </div>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </div>
        <div className="container py-6 text-center">
          <span className="text-sm uppercase">
            {__(`© ${currentYear} ASAVAGROUP CORPORATION`, 'asavagroup')}
          </span>
        </div>
      </footer>
    </>
  )
}

export default MobileFooter
